// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"344":"0f194269","703":"00fc32d6"}[chunkId] + ".chunk.css";
};